<template>
    <div id="statement_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <!-- <span class="page-title" id="CardRateHeader" v-if="$route.params.id > 0" >Discount Rates</span> -->
                    <span class="page-title" id="CardRateHeader">Customer Statement</span>
                        <div class="web-action-btn">
                            <div class="btn-groups text-right">
                            <button type="submit" class="btn btn-secondary" v-on:click.prevent="customerStatementSend('download')" >
                                Download
                            </button>
                            <button type="submit" class="btn btn-primary" v-on:click.prevent="sendMail" >
                                Send
                            </button>
                            </div>
                        </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-statement">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="CustomerStatementForm">
                                <div class="form-row row-cols-md-4 row-cols-1" v-show="!enableEmail">
                                    <div class="col form-group">
                                        <label class="control-label" for="as_of_date">As of Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="as_of_date" name="as_of_date" v-model="as_of_date" :config="optionsDate"></date-picker>
                                            <label for="as_of_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="cycle">Statement Cycle:</label>
                                        <v-select v-model="statement_cycle" name="statement_cycle" placeholder="Select Statement Cycle."
                                            label="text" :options="cycleArr">
                                        </v-select>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="customer_id">Customer:</label>
                                        <v-select v-model="customer_id" name="customer_id"
                                                label="text" :filterable="false" :options="customerArr"
                                                @search="onSearchCustomer"
                                                placeholder="Select Customer" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Customer...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error" id="customererror">{{ customererrors }}</div>
                                    </div>
                                    <div class="col btn-groups text-left">
                                        <button type="submit" class="btn btn-primary" style="margin-top:25px;" v-on:click.prevent="fetchInvoiceCustomer" >
                                            Fetch
                                        </button>
                                        <!-- <button type="submit" class="btn btn-primary" style="margin-top:20px;" v-on:click.prevent="fetchInvoiceCustomer" >
                                            Print
                                        </button> -->

                                    </div>
                                </div>
                                <div v-show="enableEmail" class="form-row ">
                                    <div class="col-md-4 form-group">
                                        <label class="control-label" for="cycle">Email:</label>
                                        <textarea class="form-control rounded-0" v-model="email" ref="textarea" id="exampleFormControlTextarea2" rows="3"></textarea>
                                        <!-- <input type="text" class="form-control" v-model="email" name="email" placeholder="Enter Email ."/> -->
                                    </div>
                                    <!-- <div class="clearfix">
                                    </div>
                                    <div class="clearfix">
                                    </div>
                                    <div class="clearfix">
                                    </div> -->
                                    <!-- <div class="btn-groups">
                                    <button type="submit" id="customerStatementSendBtn" class="btn btn-primary" v-on:click.prevent="customerStatementSend">
                                        <i class="fp-reload"> </i>  Send
                                    </button>
                                    <button type="submit" id="cancelCardRateHeaderBtn" class="btn btn-tertiary" v-on:click.prevent="enableEmail = false">
                                        <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div> -->
                                </div>
                                <p v-if="batchProcess && !batchComplete" class="alert-success p-2" id="processFetchBatchMsg">Downloading is in process. batch no. is {{batchNo}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = false, batchComplete=false"> Click Here</router-link> To view status</p>
                                <p v-if="batchComplete" class="alert-success p-2">Batch Processed Succesfully <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = false, batchComplete=false"> Click Here</router-link> to download!</p>
                                <p v-if="batchError" class="alert-danger p-2" id="processErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <!-- <button type="submit" id="customerStatementSendBtn" class="btn btn-primary" v-on:click.prevent="fetchInvoiceCustomer">
                                    <i class="fp-reload"> </i>  Fetch
                                </button> -->
                            </form>

                            <template v-if="showList && !enableEmail">
                                <data-table-filter-config :moduleName="'statementCustomerList'" ref="filterCustStatement" @cancelSelection="cancelAll"></data-table-filter-config>
                                    <!-- <div class="field-error">{{customer_error_msg}}</div> -->
                                    <section class="bg-white data-table">
                                            <custom-pagination
                                                :page-changed="onPageChange"
                                                :per-page-changed="onPerPageChange" :moduleName="'statementCustomerList'" :position="'top'">
                                            </custom-pagination>
                                            <vue-good-table
                                                ref="liststatementCustomerTable"
                                                mode="remote"
                                                title="Customer"
                                                @on-page-change="onPageChange"
                                                @on-selected-rows-change="selectionChanged"
                                                @on-column-filter="onColumnFilter"
                                                @on-per-page-change="onPerPageChange"
                                                @on-sort-change="onSortChange"
                                                @on-select-all="onSelectAll"
                                                @on-row-click="onRowClick"
                                                :totalRows="totalRecords"
                                                :columns="userColumns"
                                                :rows="rows"
                                                :pagination-options="{
                                                    enabled: false,
                                                    setCurrentPage:listCurrentPage,
                                                    perPage: perPage,
                                                }"
                                                :select-options="{
                                                enabled: true,
                                                selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
                                                selectionInfoClass: 'custom-class',
                                                selectionText: 'rows selected',
                                                clearSelectionText: 'clear',
                                                }"
                                                :search-options="{
                                                enabled: false,
                                                }">

                                            </vue-good-table>

                                            <custom-pagination
                                                :page-changed="onPageChange"
                                                :per-page-changed="onPerPageChange"
                                                >
                                            </custom-pagination>
                                    </section>
                                 </template>
                                <div class="btn-groups" v-if="enableEmail">
                                    <button type="submit" id="customerStatementSendBtn" class="btn btn-primary" v-on:click.prevent="customerStatementSend('send')">
                                        <i class="fp-reload"> </i>  Send
                                    </button>
                                    <button type="submit" id="cancelCardRateHeaderBtn" class="btn btn-tertiary" v-on:click.prevent="cancelStatement()">
                                        <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                                 <!-- <div class="btn-groups">
                                    <button type="submit" id="customerStatementSendBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="customerStatementSend" >
                                        <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="customerStatementSendBtn" v-else class="btn btn-primary" v-on:click.prevent="customerStatementSend" >
                                        <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueCardRateHeaderBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="customerStatementSend(flag='Save and Continue')" >
                                        <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelCardRateHeaderBtn" class="btn btn-tertiary" v-on:click.prevent="BackHeaderList">
                                        <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div> -->
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";
import EventBus from "./event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';
let msgServer;
export default {
  name: "ContractCreate",
  components: {
    customAssetPagination: () => import('@/components/layout/CustomPagination'),
    cardRatesCustomerList: () => import('@/components/CardRatesCustomerList'),

  },
  metaInfo() {
        return {
            title: "Customer Statement | " +process.env.COPYRIGHT_NAME
        }
  },
  mixins:[commonMixins,contractMixins,dataTableMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    cycleArr: [
        {
            text: "Monthly",
            value: "monthly"
        },
        {
            text: "Weekly",
            value: "weekly"
        },
    ],
    customer_id:'',
    customerArr:[],
    customererrors:'',
    loading:false,
    optionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
    },
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns: [
            {
                label: 'Code',
                field: 'code',
                filterable: true,
                fpFieldType:"text",
                width:'140px',
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterFn: this.onColumnFilter,
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Name',
                field: 'name',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Email',
                field: 'email',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Email", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Phone',
                field: 'work_phone',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Phone", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'City',
                field: 'city',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "City", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'State',
                field: 'state',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "State", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Stage',
                field: 'stage',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "All", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Potential', 'Account Pending', 'Credit Denied', 'New', 'Existing'],
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Created At',
                field: 'created_at',
                fpFieldType:"date",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Status',
                field: 'status',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "All", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Unverified','Active', 'Inactive'],
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Outstanding AR',
                field: 'outstanding_ar',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Outstanding AR", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
        ],
        selectedArray:[],
        email:'',
        enableEmail:false,
        buttonText:'Add Customer',
        as_of_date:'',
        statement_cycle:'',
        showList:false,
        batchId:'',
        batchNo:'',
        batchProcess:false,
        batchComplete:false,
        batchError:false,
        batchErrorMsg:""
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'list_invoice' ) {
                        self.cantAccessPage = true;
                    }
                }
            }

        }

  },
  created: function() {

  },
  beforeDestroy() {
        // Make sure to close the connection with the events server
        // when the component is destroyed, or we'll have ghost connections!
        msgServer.close();
    },
  mounted: function() {
        var self = this;
        self.getPermissions();
        var path = window.location.pathname;
        var segments = path.split("/");

        // if (segments[3]) {
        //     self.loadScopeHeader();
        // }else{
            self.loadCustomerList();
        // }
        
  },
  methods: {
      checkBatchStatus:function(){
                var self =  this;

                this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.batchId, { format: 'json' }) // or { format: 'plain' }
                .then(sse => {
                    // Store SSE object at a higher scope
                    msgServer = sse;

                    // Listen for messages without a specified event
                    sse.subscribe('', data => {
                        if ( data.status == "1") {
                            self.batchProcess = false;
                            self.batchComplete = true;
                            sse.close();

                        }else if (data.status == "2") {
                            self.batchProcess = false;
                            self.batchError = true;
                            self.batchErrorMsg = data.message;
                            sse.close();
                        }
                    });
                    
                })
                .catch(err => {
                    // When this error is caught, it means the initial connection to the
                    // events server failed.  No automatic attempts to reconnect will be made.
                    console.error('Failed to connect to server', err);
                });

            },
    cancelAll: function (cancelAll) {
      this.$refs.liststatementCustomerTable.unselectAllInternal();
    },

    onSearchCustomer(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'customer', '');
        }
    },

    customerStatementSend(flag) {
        var self = this;
        self.loading = true;

        var fields = $("#CustomerStatementForm").serializeArray();
        if (self.statement_cycle != null && self.statement_cycle.value){
            fields.push({name: "statement_cycle", value:self.statement_cycle.value});

        }else{
            fields.push({name: "statement_cycle", value:''});

        }
        fields.push({name: "seleted_all", value:self.serverParams.selectedAll});
        fields.push({name: "customer", value:JSON.stringify(self.selectedArray)});
        fields.push({name: "email", value:self.email});
        fields.push({name: "as_of_date", value:self.as_of_date});
        fields.push({name: "flag", value:flag});


        $.ajax({
            url: process.env.ROOT_API + "/customer-statement/send",
            type: "POST",
            data: fields,
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                self.enableEmail = false;
                self.as_of_date = '';
                self.statement_cycle = '';
                self.showList = false;
                self.selectedArray = [];
                self.customer_id = '';
                self.$refs.filterCustStatement.clearSelectAll();
                if(data.content.id){
                    self.batchId = data.content.id;
                    self.batchNo = data.content.batch;
                    self.batchProcess = true;
                    self.checkBatchStatus();
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'customer-statement')
            }
        });
    },

    onPageChange(params) {
        var self = this;
        this.updateParams({page: params.currentPage});
        this.listCurrentPage = params.currentPage;

        if(self.map_type && self.map_type.value == 'multiple' ){
            this.loadCustomerList();
        }
      },
      onRowClick(params){
           var self = this;
            setTimeout(function(){
                $('.vgt-selection-info-row').css({'display':'none'});
            },1);
            self.selectedAssetArray=[];
            if ($.inArray(params.row.id, self.selectedArray) != -1)
            {
                    // self.selectedArray.splice(i,1);
                var index = self.selectedArray.indexOf(params.row.id);
                if (index > -1) {
                    self.selectedArray.splice(index, 1);
                }
            }else{
                self.selectedArray.push(params.row.id);
            }
            console.log("CustomerArr"+self.selectedArray);
      },
      selectionChanged(param) {
            // var self = this;
        var self = this;
        var data = this.$refs['liststatementCustomerTable'].selectedRows;

        if (data.length && data.length > 0){
            // self.enableEmail = true;
            self.email = data[0].email;
        }
        if ((data.length && data.length > 1) || (self.selectedArray && self.selectedArray.length > 1)){
            // self.enableEmail = false;
            self.email = '';
        }

        self.serverParams.selectedAll = false;
        if(param.selectedRows.length == 100) {
          EventBus.$emit('clear-selection', false);
        } else {
          EventBus.$emit('clear-all-flags', false);
        }
        return;
      },
      findElementIndex(array, attr, value) {
            for(var i = 0; i < array.length; i += 1) {
                if(array[i][attr] === value) {
                return i;
                }
            }
            return -1;
      },
      sendMail:function(){
          var self = this;
          self.enableEmail = true;
      },
      fetchInvoiceCustomer:function(){
          var self = this;
            self.showList = true;
            self.loadCustomerList();
      },
      loadCustomerList() {

        var self = this;
        //get selected customers ids

        var selectedRows = [];
        self.serverParams.perPage=100;
        var pFilter = {};
        if ( self.as_of_date != '' ) {
            pFilter.as_of_date = self.as_of_date;
        }
        if ( self.statement_cycle != null && self.statement_cycle.value) {
            pFilter.statement_cycle = self.statement_cycle.value;
        }
        if (self.customer_id && self.customer_id.value){
            pFilter.customer_id = self.customer_id.value;
        }
        var fields = {

            page: self.serverParams.page,
            perPage: self.serverParams.perPage,
            filters: self.serverParams.columnFilters,
            statementFilter:pFilter,
            sort: self.serverParams.sort,
            flag: self.flag,
            selectedRows:selectedRows,
            action:self.action,
            selectedAll:self.serverParams.selectedAll

        };

        self.loading = true;

        self.firstLoad = 1;
        $.ajax({
            url: process.env.ROOT_API + "/customer-statement/list",
            type: "POST",
            data: fields,
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                // console.log(data);
                if (data.status == "success") {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;

                        for(var k=0;k< self.rows.length;k++){
                            if ($.inArray(self.rows[k].id, self.selectedArray) >= 0) {
                                    self.$set(self.rows[k], 'vgtSelected', true);
                                }
                        }

                        EventBus.$emit('clear-all-flags', false);
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'customer-list-error')

            }
        });
    },
    cancelStatement:function(){
        var self = this;
        self.enableEmail = false;
        if (self.rows && self.rows.length > 0){
            for(var k=0;k< self.rows.length;k++){
                if ($.inArray(self.rows[k].id, self.selectedArray) >= 0) {
                        self.$set(self.rows[k], 'vgtSelected', true);
                    }
            }
        }
    },

    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CustomerStatement.vue